import { useCallback, useState } from 'react';

/**
 * Track element width for ellipsis tooltips dynamically.
 */
export const useRevealEllipsisInTooltip = <T extends HTMLElement = HTMLDivElement>() => {
  const [width, setWidth] = useState<number>(0);

  const tooltipRef = useCallback((node: T | null) => {
    if (!node) {
      return undefined;
    }

    // Initial measurement
    setWidth(node.offsetWidth);

    // Continuous measurement via a web API
    const observer = new ResizeObserver(([entry]) => {
      if (entry) {
        setWidth(entry.contentRect.width);
      }
    });

    observer.observe(node);

    // Native callback ref cleanup
    return () => {
      observer.disconnect();
    };
  }, []);

  return {
    tooltipRef,
    width,
  };
};

export default useRevealEllipsisInTooltip;
